export default __webpack_public_path__ + "static/media/monkey11.6204aaeb.jpeg";